import React from "react";

import Redirect from "./Redirect";
import type { RouteProps } from "./routeTypes";

const index = (props: RouteProps) => [
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require("./auth").default(props),
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require("./dashboard").default(props),
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require("./legal").default(props),
  {
    path: "*",
    component: <Redirect authRedirect="" unAuthRoute="/auth" />,
  },
];

export default index;
